import React, { useState, useEffect } from 'react';

const Step5BreastSize = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.breastSize || null);

  useEffect(() => {
    // Track Meta Pixel PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, []);

  const options = [
    { value: 'small', label: 'Small', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page5-small.webp' },
    { value: 'medium', label: 'Medium', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page5-Medium.webp' },
    { value: 'large', label: 'Large', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page5-Large.webp' },
    { value: 'huge', label: 'Huge', image: 'https://cdn.lovescape.com/cdn/front/images/marketing/page5-Huge.webp' }
  ];

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          breastSize: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-selection">
      <h2 className="step-title">Is there a certain breast size you find especially attractive?</h2>
      <div className="options-grid grid-2x2">
        {options.map(option => (
          <div
            key={option.value}
            className={`option-card ${selected === option.value ? 'selected' : ''}`}
            onClick={() => handleSelect(option.value)}
          >
            <img src={option.image} alt={option.label} className="option-image" />
            <div className="option-label">{option.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step5BreastSize;